// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-select-dropdown {\n  min-width: 90px !important;\n  margin-top: 5px !important;\n}\n.el-select-dropdown .el-select-dropdown__item {\n    font-size: 12px;\n    padding: 0 10px;\n    line-height: 28px;\n    height: 28px;\n}\n", ""]);
// Exports
module.exports = exports;
